import { render } from "./AdditionEdit.vue?vue&type=template&id=3ecd7561"
import script from "./AdditionEdit.vue?vue&type=script&lang=js"
export * from "./AdditionEdit.vue?vue&type=script&lang=js"

import exportComponent from "E:\\workspacev\\vue_mypuregym\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__